import ComponentBomItem from "@/domain/proposal/ComponentBomItem";
import ComponentRouteItem from "@/domain/proposal/ComponentRouteItem";
import ComponentToolingItem from "@/domain/proposal/ComponentToolingItem";
import editable from "@/domain/decorators/editable";

export default class ComponentBom extends editable {
    componentBomID = 0;
    componentType!: string;
    componentNumber!: string;
    cBomDescription!: string;
    cBomPartWidth!: number;
    cBomPartLength!: number;
    cBomPartThickness!: number;
    cBomBlankWidth!: number;
    cBomBlankLength!: number;
    cBomBlankThickness!: number;
    cBomNumberOfStacks!: number;
    cBomInchesOfRule!: number;
    cBomEdgeProtection!: number;
    cBomHs!: string;
    cBomFs!: string;
    cBomEp!: string;
    cBomNestValue!: number;
    cBomNumberOfDrills!: number;
    cBomNumberOfHits!: number;
    cBomNumberOfHeads!: number;
    cBomNumberOfHwb!: number;
    cBomDieNumber!: string;
    cBomDieDescription!: string;
    cBomStitchTrimSlotCount!: number;
    productBomID!: number;
    cBomLineNumber!: number; //From productBom
    cBomQuantity!: number; //From productBom
    line10BomItem?: ComponentBomItem; // Deprecated
    text!: string;
    laminationSides!: number;

    totalBomCost1!: number;
    totalBomCost2!: number;
    totalBomCost3!: number;
    totalBomCost4!: number;
    totalBomCost5!: number;
    totalRouteCost1!: number;
    totalRouteCost2!: number;
    totalRouteCost3!: number;
    totalRouteCost4!: number;
    totalRouteCost5!: number;
    componentsPerDie!: number;
    tSlotter = false; // required field in db, default to false
    blankWidthWebbing!: number;
    blankLengthWebbing!: number;

    //CMP_BOM_Items table
    componentBomItems: Array<ComponentBomItem> = [];

    //CMP_Route_Items table
    componentRouteItems: Array<ComponentRouteItem> = [];

    //CMP_TOOLING_Items table
    componentToolingItems: Array<ComponentToolingItem> = [];



    constructor(init?: Partial<ComponentBom>) {
        super();
        Object.assign(this, init)
        if(init?.componentBomItems && init.componentBomItems.length > 0) this.componentBomItems = ComponentBom.initComponentBomItems(init.componentBomItems);
        if(init?.componentRouteItems && init.componentRouteItems.length > 0) this.componentRouteItems = ComponentBom.initComponentRouteItems(init.componentRouteItems);
        if(init?.componentToolingItems && init.componentToolingItems.length > 0) this.componentToolingItems = ComponentBom.initComponentToolingItems(init.componentToolingItems);
    }

    private static initComponentBomItems(bomItems: ComponentBomItem[]): Array<ComponentBomItem> {
        const array: ComponentBomItem[] = [];
        for(const bomItem of bomItems) {
            array.push(new ComponentBomItem(bomItem));
        }
        return array;
    }

    private static initComponentRouteItems(routeItems: ComponentRouteItem[]): Array<ComponentRouteItem> {
        const array: ComponentRouteItem[] = [];
        for(const routeItem of routeItems) {
            array.push(new ComponentRouteItem(routeItem));
        }
        return array;
    }

    private static initComponentToolingItems(toolingItems: ComponentToolingItem[]): Array<ComponentToolingItem> {
        const array: ComponentToolingItem[] = [];
        for(const toolingItem of toolingItems) {
            array.push(new ComponentToolingItem(toolingItem));
        }
        return array;
    }

    public compareTo(val: ComponentBom): number {
        return this.cBomLineNumber > val.cBomLineNumber ? 1 :
            this.cBomLineNumber === val.cBomLineNumber ? 0 :
                -1;
    }
}
